var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-primary"},[(_vm.preloader)?_c('app-overlay-loader'):_c('form-gen',{key:_vm.key,attrs:{"form-data-response":_vm.applyForm,"preview":true},on:{"viewForm":_vm.viewForm,"submit":_vm.updateSetting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }